import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginForm } from './LoginForm';
import './ModalLogin.scss';

type Props = {
    displayDialog: boolean,
    setDisplayDialog: any,
    setToken: any;
    logout: () => void;
}

export const ModalLogin: React.FC<Props> = ({ displayDialog, setToken, setDisplayDialog, logout }) => {

    const { t, i18n } = useTranslation('common');
    const parse_url_path = window.location.pathname.split("/");
    const client_name_from_url: string = parse_url_path[2];

    const onHideDialog = () => {
        setDisplayDialog(!displayDialog)
    }

    const renderFooter = () => {
        return (
            <div>
                <Button label="No" icon="pi pi-times" onClick={onHideDialog} className="p-button-text" />
                <Button label="Yes" icon="pi pi-check" onClick={onHideDialog} autoFocus />
            </div>
        );
    }


    return (
        <Dialog
            header={t('Session Expired')}
            visible={displayDialog}
            onHide={onHideDialog}
            breakpoints={{ '960px': '75vw' }}
            style={{ width: '50vw' }}
            closeOnEscape={false}
            closable={false}
            blockScroll={true}
        >
            <div className="login-body">
                <div className="login-wrapper modal-form">
                    <div className="login-panel">
                        <div className='my-5 flex flex-column'>
                            <h5>
                                <i className="pi pi-clock" style={{ 'fontSize': '4em' }}></i>
                            </h5>
                            <h6>{t('Your session has expired. Please login again to continue working')}</h6>
                        </div>
                        <LoginForm setToken={setToken} />
                        <Button onClick={logout} className="p-button-link mt-5" label={t('Return to Login Page')} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
}